var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Comments,_vm._g(_vm._b({staticClass:"comments-with-right-avatar",scopedSlots:_vm._u([{key:"avatar",fn:function({ user }){return [_c(_setup.PatSnapUserAvatar,{staticClass:"mr-1 size-6 leading-6",attrs:{"userId":user.user_id}})]}}])},'Comments',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }